/* tslint:disable */
/* eslint-disable */
/**
 * Survey
 * 現地調査用API
 *
 * The version of the OpenAPI document: 1.0
 * Contact: kiuchi@wcdi.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CostcoProductLog } from './CostcoProductLog';
import {
    CostcoProductLogFromJSON,
    CostcoProductLogFromJSONTyped,
    CostcoProductLogToJSON,
} from './CostcoProductLog';

/**
 * 
 * @export
 * @interface GetCostcoProductLog200ResponseAllOfData
 */
export interface GetCostcoProductLog200ResponseAllOfData {
    /**
     * 
     * @type {CostcoProductLog}
     * @memberof GetCostcoProductLog200ResponseAllOfData
     */
    costcoProductLog: CostcoProductLog;
}

/**
 * Check if a given object implements the GetCostcoProductLog200ResponseAllOfData interface.
 */
export function instanceOfGetCostcoProductLog200ResponseAllOfData(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "costcoProductLog" in value;

    return isInstance;
}

export function GetCostcoProductLog200ResponseAllOfDataFromJSON(json: any): GetCostcoProductLog200ResponseAllOfData {
    return GetCostcoProductLog200ResponseAllOfDataFromJSONTyped(json, false);
}

export function GetCostcoProductLog200ResponseAllOfDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetCostcoProductLog200ResponseAllOfData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'costcoProductLog': CostcoProductLogFromJSON(json['costco_product_log']),
    };
}

export function GetCostcoProductLog200ResponseAllOfDataToJSON(value?: GetCostcoProductLog200ResponseAllOfData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'costco_product_log': CostcoProductLogToJSON(value.costcoProductLog),
    };
}

